/**
 * Lazily loads partviewer's DXF parsing service.
 *
 * `vectorEditor`'s saga is registered eagerly (`modules/index.ts`), and
 * `dxfService` reaches three.js via `geom-utils`/`step/utils`, so importing it at
 * module scope pulled the whole engine into the app's initial bundle. Deferring it
 * to first use is what keeps three out of it.
 *
 * A `.js` file for the same reason `cadViewer/components/PartViewer.js` is: under
 * `moduleResolution: node16` TypeScript resolves a dynamic `import()` with ESM
 * rules, which require an explicit file extension on a deep subpath — and webpack
 * here has no `extensionAlias` to map `.js` back to `.ts`. Callers annotate the
 * result with the exported `DxfService` type, so nothing is lost.
 *
 * The module registry caches this, so the service keeps its singleton semantics.
 */
export const loadDxfService = () =>
  import(
    /* webpackChunkName: 'dxf_service' */ '@frontend/partviewer/src/loaders/dxf/service'
  );
